/* eslint-disable camelcase */
import * as marietta from '../..';
import { ITEM_MODE_KEY } from '../Constants';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';

// 住設・家具以外のピッカーの最小間隔(px)。従来の値
const DEFAULT_MIN_PICKER_GAP_PIX: number = 10;

/**
 *itemcontrollerクラス
 */
export default class ItemController {
  // viewObj;
  target: marietta.webcad.item.MonicaObject;

  dragObj_T: marietta.webcad.control.parts.ControlPicker;

  dragObj_TL: marietta.webcad.control.parts.ControlPicker;

  dragObj_TR: marietta.webcad.control.parts.ControlPicker;

  dragObj_L: marietta.webcad.control.parts.ControlPicker;

  dragObj_R: marietta.webcad.control.parts.ControlPicker;

  dragObj_B: marietta.webcad.control.parts.ControlPicker;

  dragObj_BL: marietta.webcad.control.parts.ControlPicker;

  dragObj_BR: marietta.webcad.control.parts.ControlPicker;

  btnDelete: marietta.webcad.control.parts.ButtonGarbage;

  btnReverse: marietta.webcad.control.parts.ButtonReverse;

  btnDragger: marietta.webcad.control.parts.DraggerMobile;

  allBox: marietta.webcad.control.parts.BoundingBox;

  rotator: marietta.webcad.control.parts.ControlRotator;

  startPoint: marietta.core.Point;

  x: number;

  y: number;

  rotation: number;

  width: number;

  height: number;

  dragStartPoint: marietta.core.Point;

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    // ターゲット
    this.target = _target;
    this.initMe();
  }

  initMe() {
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor) as marietta.webcad.layer.FloorShitaeLayer;

    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    // viewObj.setAttribute("transform", this.target.getCurrentTransform() );

    // 全体のボックス
    this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);

    // 回転
    this.rotator = new marietta.webcad.control.parts.ControlRotator(viewObj);
    this.rotator.rotateStartFunc = () => this.rotateStart();
    this.rotator.rotateFunc = this.rotate;
    this.rotator.rotateEndFunc = () => this.rotateEnd();

    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete = new marietta.webcad.control.parts.ButtonGarbage(viewObj, this.target);
      // 反転ボタン
      this.btnReverse = new marietta.webcad.control.parts.ButtonReverse(viewObj, this.target);
      // 移動軸
      this.btnDragger = new marietta.webcad.control.parts.DraggerMobile(viewObj, this.target);
      this.btnDragger.dragFunc = this.onMoveDragger;
      this.btnDragger.dragEndFunc = this.onMoveEndDragger;
    }

    // ピッカー
    this.dragObj_T = new marietta.webcad.control.parts.ControlPicker(viewObj, 'T');
    this.dragObj_T.moveFunc = this.onMoveControlPicker;
    this.dragObj_T.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_TL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TL');
    this.dragObj_TL.moveFunc = this.onMoveControlPicker;
    this.dragObj_TL.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_TR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TR');
    this.dragObj_TR.moveFunc = this.onMoveControlPicker;
    this.dragObj_TR.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_L = new marietta.webcad.control.parts.ControlPicker(viewObj, 'L');
    this.dragObj_L.moveFunc = this.onMoveControlPicker;
    this.dragObj_L.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_R = new marietta.webcad.control.parts.ControlPicker(viewObj, 'R');
    this.dragObj_R.moveFunc = this.onMoveControlPicker;
    this.dragObj_R.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_B = new marietta.webcad.control.parts.ControlPicker(viewObj, 'B');
    this.dragObj_B.moveFunc = this.onMoveControlPicker;
    this.dragObj_B.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_BL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BL');
    this.dragObj_BL.moveFunc = this.onMoveControlPicker;
    this.dragObj_BL.moveEndFunc = this.onMoveEndControlPicker;
    this.dragObj_BR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BR');
    this.dragObj_BR.moveFunc = this.onMoveControlPicker;
    this.dragObj_BR.moveEndFunc = this.onMoveEndControlPicker;

    // モバイル
    if (ua.isMobile || ua.isTablet) {
      this.dragObj_T.hide();
      this.dragObj_L.hide();
      this.dragObj_R.hide();
      this.dragObj_B.hide();
    }
    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }

    // エンドアイテムが決まっている場合は、サイズ変更できないので、非表示にする
    if (!this.target.itemInfo.isWhiteItem()) {
      this.dragObj_T.hide();
      this.dragObj_TL.hide();
      this.dragObj_TR.hide();
      this.dragObj_L.hide();
      this.dragObj_R.hide();
      this.dragObj_B.hide();
      this.dragObj_BL.hide();
      this.dragObj_BR.hide();
    }

    // 中心点確認用
    // var center = new marietta.webcad.control.parts.ControlPicker( viewObj, "c" );
    // center.move(0,0);

    tarLayer.viewObj.appendChild(viewObj);

    this.spt = new SVGSprite(viewObj);

    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
    // this.cutRooms();
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();

    // 一度回転角度を戻してサイズを計測する
    const motoRot: number = this.target.itemInfo.rotation;
    this.target.rotate(0);

    // var rect = this.target.viewObj.getBoundingClientRect();

    // SVGSpriteのwidth/heightに書き換え
    let { width } = this.target.spt;
    let { height } = this.target.spt;
    if (this.target instanceof marietta.webcad.item.Stair) {
      width = Math.abs((this.target as marietta.webcad.item.Stair).patternSpt.width);
      height = (this.target as marietta.webcad.item.Stair).patternSpt.height;
    }
    // rect.width = width;
    // rect.height = height;

    // Debugger.log(rect.width + " $$ " + rect.height);
    // Debugger.log(width + " $$$ " + height);

    // ピッカー
    this.dragObj_T.move(0, -height / 2);
    this.dragObj_TL.move(-width / 2, -height / 2);
    this.dragObj_TR.move(width / 2, -height / 2);
    this.dragObj_L.move(-width / 2, 0);
    this.dragObj_R.move(width / 2, 0);
    this.dragObj_B.move(0, height / 2);
    this.dragObj_BL.move(-width / 2, height / 2);
    this.dragObj_BR.move(width / 2, height / 2);

    // 直接、transformをいじらずにmove()関数などを通す
    // 回転
    // this.rotator.transformMatrix = "matrix(1,0,0,1," + -6.5 + "," + (-height/2 - 25) + ")";
    // this.rotator.viewObj.setAttribute("transform", this.rotator.transformMatrix);
    this.rotator.move(-6.5, (-height / 2 - 25));

    // アイコンボタンの位置更新
    this.updateIconButtons();

    // 全体Box
    // rectのwidth/heightプロパティに値が代入出来ないので
    // 直接渡すことに（Firefoxのみ値渡しが出来ていたっぽい）
    this.allBox.resize({ width, height });
    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
    // this.allBox.resize( rect );

    // 回転角度を元に戻す
    this.target.rotate(motoRot);

    this.rotation = motoRot;
    this.updateTransforms();
  }

  /**
   * アイコンボタンの更新
   */
  updateIconButtons() {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete.move(this.dragObj_TR.x + 35, this.dragObj_TR.y + (this.dragObj_BR.y - this.dragObj_TR.y) / 2);
      // 反転ボタン
      this.btnReverse.move(this.dragObj_TL.x - 35, this.dragObj_TR.y + (this.dragObj_BR.y - this.dragObj_TR.y) / 2);
      // 移動軸
      this.btnDragger.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_BL.y + 35);
    }
  }

  /**
   * ターゲットにシンクロする
   * ※アイテムのドラッグ時に呼び出される
   */
  syncMeToTarget() {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.rotation = this.target.itemInfo.rotation;
    this.updateTransforms();
  }

  /**
   * 回転の開始（位置のリセット）
   * @param MouseEvent
   */
  rotateStart = () => {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.updateTransforms();

    let { width } = this.target.spt;
    let { height } = this.target.spt;
    if (this.target instanceof marietta.webcad.item.Stair) {
      width = (this.target as marietta.webcad.item.Stair).patternSpt.width;
      height = (this.target as marietta.webcad.item.Stair).patternSpt.height;
    }

    // ピッカー
    this.dragObj_T.move(0, -height / 2);
    this.dragObj_TL.move(-width / 2, -height / 2);
    this.dragObj_TR.move(width / 2, -height / 2);
    this.dragObj_L.move(-width / 2, 0);
    this.dragObj_R.move(width / 2, 0);
    this.dragObj_B.move(0, height / 2);
    this.dragObj_BL.move(-width / 2, height / 2);
    this.dragObj_BR.move(width / 2, height / 2);
    this.rotator.move(-6.5, (-height / 2 - 25));

    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
  };

  /**
   * 回転する
   * @param MouseEvent
   */
  rotate = (e: MouseEvent) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfRotate()) return;
    // const rect = this.target.viewObj.getBoundingClientRect();
    const firstPoint: marietta.core.Point = new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y);
    const newPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const secondPoint: marietta.core.Point = new marietta.core.Point(newPoint.x, newPoint.y);

    // レイヤーのスケーリング分を考慮
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    secondPoint.x -= Stage.offsetX - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
    secondPoint.y -= Stage.offsetY - marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
    secondPoint.x /= root.scaleX;
    secondPoint.y /= root.scaleY;

    // 角度
    const radian: number = Math.atan2((firstPoint.x - secondPoint.x), (firstPoint.y - secondPoint.y));
    let angle: number = -radian / (Math.PI / 180) + 360;
    let unit: number = 45;
    if (this.target instanceof marietta.webcad.item.Stair) {
      unit = 90;
    }

    if (angle % unit > 5 && angle % unit < unit - 5) {
      this.rotator.showAssist(false);
    } else {
      this.rotator.showAssist(true);
      angle = Math.round(angle / unit) * unit;
    }

    this.rotation = angle;
    this.updateTransforms();

    // ターゲットを回転
    this.target.rotate(angle);

    if (this.emptySpt) {
      this.emptySpt.setEmptyParam(this.target.spt);
    }
  }

  /**
   * 回転する（終了）
   * @param MouseEvent
   */
  rotateEnd = () => {
    if (this.target instanceof marietta.webcad.item.Stair) {
      this.rotation = Math.round(this.rotation / 90) * 90;
      this.updateTransforms();

      // ターゲットを回転
      this.target.rotate(this.rotation);

      // ライン測定を更新する
      const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
      const targetKey = targetId.substring(0, 3);
      if (targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
        marietta.webcad.WebCADGlobal.updateMeasureLine();
      }
    }
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveControlPicker = (e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) => {
    // オーバーライドできるように引き渡す
    // Stair CornerDragの開始時に測定線を非表示にする
    // ライン測定を更新する
    const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
    const targetKey = targetId.substring(0, 3);
    if (targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
      marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();
    }
    this.moveControlPicker(e, target);
  }

  /**
   * 向かい合うピッカーの最小間隔(px)。住設・家具は数値入力と同じ幅・奥行の下限(mm)に合わせる
   */
  protected getMinPickerGap(): number {
    if (!this.target || !this.target.isHeightEditableItem()) return DEFAULT_MIN_PICKER_GAP_PIX;
    return marietta.webcad.util.WebCADUtil.convertMMToPix(this.target.getMinPlanSizeMM());
  }

  /**
   * コントロールピッカーが移動された
   */
  moveControlPicker(e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;

    // 開始時のアイテム場所保持
    if (this.startPoint === undefined) {
      // this.startPoint = new marietta.core.Point( this.target.itemInfo.x, this.target.itemInfo.y );

      if (this.emptySpt === undefined) {
        /*
              本来はtarget.sptのmouseX/mouseYで取得できるが、
              拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
              そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
              取得している。
              */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      this.startPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );

      // added k.kubonaka (WEBCAD-1020対応)
      this.resizeToTarget();
    }

    // var newPoint:marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const newPoint: marietta.core.Point = new marietta.core.Point(
      this.emptySpt.mouseX * this.target.spt.scaleX,
      this.emptySpt.mouseY * this.target.spt.scaleY,
    );

    // アイテムの角度分、座標変換を行う
    const r: number = -((this.target.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);

    newPoint.x = xx;
    newPoint.y = yy;

    // 他のピッカーの制限
    const minGap: number = this.getMinPickerGap();
    switch (target) {
      case this.dragObj_T:
        if (this.dragObj_B.y - minGap < newPoint.y) newPoint.y = this.dragObj_B.y - minGap;
        break;
      case this.dragObj_B:
        if (this.dragObj_T.y + minGap > newPoint.y) newPoint.y = this.dragObj_T.y + minGap;
        break;
      case this.dragObj_L:
        if (this.dragObj_R.x - minGap < newPoint.x) newPoint.x = this.dragObj_R.x - minGap;
        break;
      case this.dragObj_R:
        if (this.dragObj_L.x + minGap > newPoint.x) newPoint.x = this.dragObj_L.x + minGap;
        break;
      case this.dragObj_TL:
        if (this.dragObj_B.y - minGap < newPoint.y) newPoint.y = this.dragObj_B.y - minGap;
        if (this.dragObj_R.x - minGap < newPoint.x) newPoint.x = this.dragObj_R.x - minGap;
        break;
      case this.dragObj_TR:
        if (this.dragObj_B.y - minGap < newPoint.y) newPoint.y = this.dragObj_B.y - minGap;
        if (this.dragObj_L.x + minGap > newPoint.x) newPoint.x = this.dragObj_L.x + minGap;
        break;
      case this.dragObj_BL:
        if (this.dragObj_T.y + minGap > newPoint.y) newPoint.y = this.dragObj_T.y + minGap;
        if (this.dragObj_R.x - minGap < newPoint.x) newPoint.x = this.dragObj_R.x - minGap;
        break;
      case this.dragObj_BR:
        if (this.dragObj_T.y + minGap > newPoint.y) newPoint.y = this.dragObj_T.y + minGap;
        if (this.dragObj_L.x + minGap > newPoint.x) newPoint.x = this.dragObj_L.x + minGap;
        break;
      default: break;
    }

    // ｘ’＝ｘcosθ-ysinθ
    // ｙ’＝ｘsinθ+ycosθ

    // ドラッグ範囲
    // 他のピッカーの整理
    switch (target) {
      case this.dragObj_T:
      case this.dragObj_B:
        target.moveY(newPoint.y/* - this.target.itemInfo.y */);
        break;
      case this.dragObj_L:
      case this.dragObj_R:
        target.moveX(newPoint.x/* - this.target.itemInfo.x */);
        break;
      default:
        target.move(newPoint.x/* - this.target.itemInfo.x */, newPoint.y/* - this.target.itemInfo.y */);
        break;
    }

    // 他のピッカーの整理
    switch (target) {
      case this.dragObj_T:
        this.dragObj_TR.moveY(target.y);
        this.dragObj_TL.moveY(target.y);
        break;
      case this.dragObj_B:
        this.dragObj_BR.moveY(target.y);
        this.dragObj_BL.moveY(target.y);
        break;
      case this.dragObj_L:
        this.dragObj_TL.moveX(target.x);
        this.dragObj_BL.moveX(target.x);
        break;
      case this.dragObj_R:
        this.dragObj_TR.moveX(target.x);
        this.dragObj_BR.moveX(target.x);
        break;
      case this.dragObj_TL:
        this.dragObj_L.moveX(target.x);
        this.dragObj_BL.moveX(target.x);
        this.dragObj_TR.moveY(target.y);
        this.dragObj_T.moveY(target.y);
        break;
      case this.dragObj_TR:
        this.dragObj_R.moveX(target.x);
        this.dragObj_BR.moveX(target.x);
        this.dragObj_TL.moveY(target.y);
        this.dragObj_T.moveY(target.y);
        break;
      case this.dragObj_BL:
        this.dragObj_L.moveX(target.x);
        this.dragObj_TL.moveX(target.x);
        this.dragObj_BR.moveY(target.y);
        this.dragObj_B.moveY(target.y);
        break;
      case this.dragObj_BR:
        this.dragObj_R.moveX(target.x);
        this.dragObj_TR.moveX(target.x);
        this.dragObj_BL.moveY(target.y);
        this.dragObj_B.moveY(target.y);
        break;
      default: break;
    }
    this.rotator.move(this.dragObj_T.x - 6.5, this.dragObj_T.y - 25);

    // 中点の再配置
    switch (target) {
      case this.dragObj_T:
      case this.dragObj_B:
        this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        break;
      case this.dragObj_L:
      case this.dragObj_R:
        this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        break;
      default:
      case this.dragObj_TL:
      case this.dragObj_TR:
      case this.dragObj_BL:
      case this.dragObj_BR:
        this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        break;
    }

    // Debugger.log("BR " + this.dragObj_BR.x + " " + this.dragObj_BL.x);

    // 矩形のサイズ変更
    const rect = {
      x: this.dragObj_BL.x, y: this.dragObj_BL.y, width: (this.dragObj_BR.x - this.dragObj_BL.x), height: (this.dragObj_BR.y - this.dragObj_TR.y),
    };
    this.allBox.resize(rect);

    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);

    // ターゲットのリサイズ
    this.resizeTarget();

    // アイコンボタンの位置更新
    this.updateIconButtons();
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndControlPicker = () => {
    // 階段の場合は、サイズ更新
    if (this.target instanceof marietta.webcad.item.Stair) {
      // ターゲットのリサイズ
      this.resizeTarget();
      this.target.spt.visible = true;
      this.target.spt.update();
    }

    this.startPoint = undefined;

    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = undefined;
    }

    // アイコンボタンの位置更新
    this.updateIconButtons();

    // ライン測定を更新する
    const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
    const targetKey = targetId.substring(0, 3);
    if (targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
      marietta.webcad.WebCADGlobal.updateMeasureLine();
      // StaircornerDragの最後に測定線を表示する
      marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
    }
    if (targetKey === ITEM_MODE_KEY.MODE_EXTERIOR_KEY) {
      marietta.webcad.WebCADGlobal.quotationItemList.createData();
    }
  }

  /**
   * ピッカーで決めたサイズ(px)。住設・家具は mm を1mm単位で保つため、整数に丸める allBox ではなくピッカーの間隔から取る
   */
  protected getResizeSize(): { width: number, height: number } {
    if (!this.target.isHeightEditableItem()) return { width: this.allBox.width, height: this.allBox.height };
    return { width: this.dragObj_BR.x - this.dragObj_BL.x, height: this.dragObj_BR.y - this.dragObj_TR.y };
  }

  /**
   * ターゲットのリサイズ
   * */
  resizeTarget() {
    // サイズ変更
    const { width: w, height: h } = this.getResizeSize();
    // Debugger.log("w " + this.target.itemInfo.width + " -> " + w);
    this.target.changeSize(w, h, true);
    if (this.emptySpt !== undefined) {
      // マウス位置の換算は描画と同じ px（最低1px）で揃える。0 に丸めると倍率が 0 になりマウス位置が無限大になる
      this.emptySpt.width = Math.round(marietta.webcad.item.MonicaObject.floorDrawSizePix(w));
      this.emptySpt.height = Math.round(marietta.webcad.item.MonicaObject.floorDrawSizePix(h));
    }

    // 中心点を計算
    const rect = this.allBox.viewObj.getBoundingClientRect();
    /*
      rectのleft/topでは正しい位置が取れないため、rect.left/rect.topは使用せず以下で計算する。

      基本的にrectのleft/topの値からステージの移動分（x/yのスクロール位置）を
      引いているだけ。
      Stage.offsetX/offsetYは、絶対位置なので、WebCADGlobalの
      OUTERFRAME_LEFT_FRAME_WIDTHなどの値の分も含んでいる
    */
    const left: number = (rect.left) - Stage.offsetX;
    const top: number = (rect.top) - Stage.offsetY;
    // 位置調整
    // 一番ルートであるLayerGroupの倍率をで割る事で拡縮時でもずれないように
    // layerGroupが持つSpriteのscaleX/scaleyで取得可能
    const stage: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    this.target.move((left + (rect.width / 2)) / stage.scaleX/* - 200 */, (top + (rect.height / 2)) / stage.scaleY /* - 50 */);
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    // this.viewObj.setAttribute("transform", this.getCurrentTransform());
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.rotation = this.rotation;
    this.spt.update();
  }

  public updatePickers(): void {
    this.rotator.updateTranslate();
    this.dragObj_T.updateTranslate();
    this.dragObj_TL.updateTranslate();
    this.dragObj_TR.updateTranslate();
    this.dragObj_L.updateTranslate();
    this.dragObj_R.updateTranslate();
    this.dragObj_B.updateTranslate();
    this.dragObj_BL.updateTranslate();
    this.dragObj_BR.updateTranslate();

    // モバイルの場合
    if (this.btnDelete != null) {
      this.btnDelete.updateTranslate();
      this.btnReverse.updateTranslate();
      this.btnDragger.updateTranslate();
    }
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveDragger = () => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfMove()) return;
    // 開始時のアイテム場所保持
    if (this.dragStartPoint === undefined || this.dragStartPoint === null) {
      if (this.emptySpt === undefined) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.btnDragger.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      // アイテムの元位置
      this.dragStartPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );
      // ドラッグの開始位置
      this.dragStartPoint = new marietta.core.Point(
        this.target.spt.mouseX * this.target.spt.scaleX,
        this.target.spt.mouseY * this.target.spt.scaleY,
      );
    }

    const newPoint: marietta.core.Point = new marietta.core.Point(
      marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX,
      marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY,
    );
    const moveX: number = newPoint.x - this.dragStartPoint.x;
    const moveY: number = newPoint.y - this.dragStartPoint.y;

    // ターゲットの移動
    this.target.move(moveX, moveY);
    this.target.snapToWall();
    // ターゲットに吸着
    this.syncMeToTarget();
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndDragger = () => {
    this.dragStartPoint = null;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }
    // カレントを入れ直す前に呼んで、移動後の値を H 欄に出す
    marietta.webcad.WebCADGlobal.itemManager.onItemsMoved();
    // マウスアップの挙動
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
  }

  /**
   * ツールチップを非表示
   */
  hideToolTips() {
    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.hide();
      this.btnDragger.hide();
      this.btnReverse.hide();
    }
    this.rotator.hide();

    this.dragObj_T.disablePicker();
    this.dragObj_TL.disablePicker();
    this.dragObj_TR.disablePicker();
    this.dragObj_L.disablePicker();
    this.dragObj_R.disablePicker();
    this.dragObj_B.disablePicker();
    this.dragObj_BL.disablePicker();
    this.dragObj_BR.disablePicker();
  }

  /**
   * ツールチップを表示する
   */
  showToolTips() {
    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.show();
      this.btnDragger.show();
      this.btnReverse.show();
    }
    this.rotator.show();

    this.dragObj_T.enablePicker();
    this.dragObj_TL.enablePicker();
    this.dragObj_TR.enablePicker();
    this.dragObj_L.enablePicker();
    this.dragObj_R.enablePicker();
    this.dragObj_B.enablePicker();
    this.dragObj_BL.enablePicker();
    this.dragObj_BR.enablePicker();
  }

  /**
   * 選択したGroupItemを整列します
   * @param align type= string; values = "top", "bottom", "right", "left", "verticalCenter", "horizontalCenter" etc
   * @return void
  * */
  static align(align:string = '') {
    if (align === '') return;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup === null) return;
    const rect:marietta.core.Rectangle = new marietta.core.Rectangle();
    const groupRect:marietta.core.Rectangle = ItemController.getGroupRectangle();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.forEach((value) => {
      rect.x = value.itemInfo.x;
      rect.y = value.itemInfo.y;
      rect.width = value.itemInfo.width;
      rect.height = value.itemInfo.height;
      let boundRect:marietta.core.Rectangle = new marietta.core.Rectangle();
      boundRect = ItemController.getBoundingClientRect(value);
      const alignPos:marietta.core.Point = ItemController.getAlignPos(rect, boundRect, groupRect, align);
      const item = value;
      item.itemInfo.x = alignPos.x;
      item.itemInfo.y = alignPos.y;
      item.updateTransforms();
    });
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.createImage();
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
   * 等間隔の配置
   * @param align type= string; values = "horizontal", "vertical" etc
   * @return void
  * */
  static equalAlign(align:string = '') {
    if (align === '') return;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup === null) return;
    const xy:string = (align === 'horizontal') ? 'x' : 'y';
    const wh:string = (align === 'horizontal') ? 'width' : 'height';
    const groupRect:marietta.core.Rectangle = ItemController.getGroupRectangle();
    const sumRect:marietta.core.Rectangle = ItemController.getSumRect();
    const gap:number = (groupRect[wh] - sumRect[wh]) / (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.length - 1);
    if (gap < 0) {
      // gap = 0;
    }
    const myItemList:marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.concat();
    myItemList.sort((a:marietta.webcad.item.MonicaObject, b:marietta.webcad.item.MonicaObject) => {
      const boundRectA:marietta.core.Rectangle = ItemController.getBoundingClientRect(a);
      const boundRectB:marietta.core.Rectangle = ItemController.getBoundingClientRect(b);
      if (boundRectA[xy] < boundRectB[xy]) return -1;
      if (boundRectA[xy] > boundRectB[xy]) return 1;
      return 0;
    });

    let nextPos:number = 0;
    myItemList.forEach((value:marietta.webcad.item.MonicaObject) => {
      const boundRect:marietta.core.Rectangle = ItemController.getBoundingClientRect(value);
      const item = value;
      item.itemInfo[xy] = groupRect[xy] + nextPos + (item.itemInfo[xy] - boundRect[xy]);
      item.updateTransforms();
      nextPos += boundRect[wh] + gap;
    });
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.createImage();
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
   * 選択されている全てのアイテムの横幅縦幅の合計を取得する
   * @return marietta.core.Rectangle
  * */
  static getSumRect() {
    const sum:marietta.core.Rectangle = new marietta.core.Rectangle();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.forEach((value) => {
      const boundRect:marietta.core.Rectangle = ItemController.getBoundingClientRect(value);
      sum.width += boundRect.width;
      sum.height += boundRect.height;
    });
    return sum;
  }

  /**
   * グループアイテムのRectを取得する
   * @return marietta.core.Rectangle
  * */
  private static getGroupRectangle() {
    const rect:marietta.core.Rectangle = new marietta.core.Rectangle();
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.forEach((value:marietta.webcad.item.MonicaObject, index:number) => {
      const boundRect:marietta.core.Rectangle = ItemController.getBoundingClientRect(value);
      if (index === 0) {
        rect.x = boundRect.x;
        rect.y = boundRect.y;
        rect.width = boundRect.x + boundRect.width;
        rect.height = boundRect.y + boundRect.height;
        return;
      }
      if (boundRect.x < rect.x) {
        rect.x = boundRect.x;
      }
      if (boundRect.y < rect.y) {
        rect.y = boundRect.y;
      }
      if (rect.width < (boundRect.x + boundRect.width)) {
        rect.width = boundRect.x + boundRect.width;
      }
      if (rect.height < (boundRect.y + boundRect.height)) {
        rect.height = boundRect.y + boundRect.height;
      }
    });
    rect.width -= rect.x;
    rect.height -= rect.y;
    return rect;
  }

  /**
   * 整列座標の取得
   * @param rect type = Rectangle; 各グループ項目の位置とサイズのデータ（単一項目）
   * @param boundRect type = Group; 各アイテムgetBoundingClientRectデータ
   * @param groupRect type = Rectangle; getGroupRectangle関数からグループデータを取得する
   * @param align  type = string; グループアイテムの配置タイプ
   * @return marietta.core.Point
   *
  * */
  private static getAlignPos(rect:marietta.core.Rectangle, boundRect:marietta.core.Rectangle, groupRect:marietta.core.Rectangle, align:string) {
    const alignPos:marietta.core.Point = new marietta.core.Point(undefined, undefined);
    switch (align) {
      case 'left':
        alignPos.x = groupRect.x + (rect.x - boundRect.x);
        alignPos.y = rect.y;
        break;
      case 'right':
        alignPos.x = groupRect.x + groupRect.width + (rect.x - boundRect.x) - boundRect.width;
        alignPos.y = rect.y;
        break;
      case 'top':
        alignPos.x = rect.x;
        alignPos.y = groupRect.y + (rect.y - boundRect.y);
        break;
      case 'bottom':
        alignPos.x = rect.x;
        alignPos.y = groupRect.y + groupRect.height + (rect.y - boundRect.y) - boundRect.height;
        break;
      case 'horizontalCenter':
        alignPos.x = groupRect.x + (groupRect.width / 2) + (rect.x - boundRect.x) - boundRect.width / 2;
        alignPos.y = rect.y;
        break;
      case 'verticalCenter':
        alignPos.x = rect.x;
        alignPos.y = groupRect.y + (groupRect.height / 2) + (rect.y - boundRect.y) - boundRect.height / 2;
        break;
      default: break;
    }
    return alignPos;
  }

  /**
   * Monicaobject境界位置データを取得します
   * @param object MonicaObject
   * @return marietta.core.Rectangle
  * */
  private static getBoundingClientRect(object:marietta.webcad.item.MonicaObject) {
    const clientRect = object.getBoundingClientRect();
    const rect:marietta.core.Rectangle = new marietta.core.Rectangle();
    rect.x = clientRect.left / marietta.webcad.WebCADGlobal.scaleSize;
    rect.y = clientRect.top / marietta.webcad.WebCADGlobal.scaleSize;
    rect.width = clientRect.width / marietta.webcad.WebCADGlobal.scaleSize;
    rect.height = clientRect.height / marietta.webcad.WebCADGlobal.scaleSize;
    return rect;
  }
}
